import { css } from "emotion";
import { max } from "../utils/CssUtils";

const totalBlock = css({
  display: "none",
  [max(768)]: {
    display: "inline-block",
    p: {
      fontWeight: 600,
      marginBottom: 2,
      fontSize: 14,
      lineHeight: "14px"
    }
  }
});
const OrderTotal = ({ orderSummary }) => {
  if (
    orderSummary &&
    !orderSummary.loading &&
    orderSummary.data &&
    orderSummary.data.total
  ) {
    return (
      <div className={totalBlock}>
        <p>Total:</p>
        <p>${orderSummary.data.total.toFixed(2)}</p>
      </div>
    );
  }
};

export default OrderTotal;



// WEBPACK FOOTER //
// ./components/OrderTotal.js